module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point03-3-5b08a04e25e6db60a63d70848dae0fa4.jpg";